(function () {
  const COOKIE_KEY = 'kikkig_geo_dismissed';

  function getCookie(name) {
    return document.cookie.split('; ').find(r => r.startsWith(name + '='));
  }

  function setCookie(name, value) {
    document.cookie = `${name}=${value};path=/`;
  }

  function showPopup(overlay) {
    setTimeout(() => overlay.classList.add('active'), 300);
  }

  function initPopup() {
    const overlay = document.getElementById('geo-popup-overlay');
    if (!overlay) return;

    const isEditor = window.Shopify && window.Shopify.designMode;

    // Always show in editor, respect cookie on storefront
    if (isEditor || !getCookie(COOKIE_KEY)) {
      showPopup(overlay);
    }

    document.getElementById('geo-close').addEventListener('click', function () {
      overlay.classList.remove('active');
      if (!isEditor) setCookie(COOKIE_KEY, '1');
    });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.classList.remove('active');
        if (!isEditor) setCookie(COOKIE_KEY, '1');
      }
    });

    document.getElementById('geo-change-region').addEventListener('click', function () {
      const section = document.getElementById('geo-country-section');
      section.style.display = section.style.display === 'block' ? 'none' : 'block';
    });

    document.getElementById('geo-localization-form').addEventListener('submit', function () {
      if (!isEditor) setCookie(COOKIE_KEY, '1');
    });
  }

  // Handle editor section select event
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail.sectionId === 'geo-popup') {
      const overlay = document.getElementById('geo-popup-overlay');
      if (overlay) overlay.classList.add('active');
    }
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail.sectionId === 'geo-popup') {
      const overlay = document.getElementById('geo-popup-overlay');
      if (overlay) overlay.classList.remove('active');
    }
  });

  document.addEventListener('DOMContentLoaded', initPopup);
})();